import { render, staticRenderFns } from "./itens_mobile.vue?vue&type=template&id=2a655bf7"
import script from "./itens_mobile.vue?vue&type=script&lang=js"
export * from "./itens_mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports